/* eslint-disable jira/filename-case */
export const HEIGHT = 64;
export const NAME = 'ANNOUNCEMENT' as const;
